import React  from "react";
import { useParams } from 'react-router-dom';
import RegisteredAnimalsForm from "./components/RegisteredAnimalsForm";

const ViewRegisteredAnimal = () => {
	const { registeredanimalId } = useParams();
	console.log(registeredanimalId);
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<RegisteredAnimalsForm recordId={registeredanimalId} mode="view"/>
	      </div>
	    </div>
    );
};

export default ViewRegisteredAnimal;